import { FC } from 'react';
import { Form, Space, Switch } from 'antd';
import { ESwitchEnum } from '@/pages/backend/cardCampSettings/nodeSettings/switchEnum';
import RemindTime from '@/pages/backend/cardCampSettings/nodeSettings/remindTime';
import dayjs from 'dayjs';

const NodeRemind: FC<{ value?: any; onChange?: (data: any) => void }> = (props) => {
  const { value, onChange } = props;
  const form = Form.useFormInstance();
  const remind = Form.useWatch('remind', form);

  return (
    <div>
      <Space>
        <Switch
          value={value}
          onChange={(checked) => {
            if (checked) {
              form.setFieldsValue({ remindDays: 0, remindTime: dayjs('18:00', 'HH:mm') });
            }
            onChange?.(checked ? ESwitchEnum.open : ESwitchEnum.close);
          }}
        />
        <span className="text-c0c0c0">开启后如果在设定的时间未完成打卡，将会通过短信提醒学员</span>
      </Space>
      {remind === ESwitchEnum.open && <RemindTime />}
    </div>
  );
};
export default NodeRemind;
